<template>
    <div :class="['login-component', { 'login-modal-container': isModal }]">
        <div class="login-izq">
            <div v-if="!isModal" class="login-footer">
                <a href="https://www.laizquierdadiario.com" target="_blank">
                    <img src="@/assets/logo_ar.svg" alt="La Izquierda Diario" />
                </a>
                <a href="https://www.laizquierdadiario.com/Red-Internacional/">
                    <img src="@/assets/logo_red_internacional_lid.svg" alt="Red Internacional La Izquierda Diario" />
                </a>
            </div>
            <div class="prompt-suggestions-carrousel">
                <div class="prompt-suggestions-slides-container">
                    <div v-for="prompt in promptSuggestions" :key="prompt.id">
                        <ion-icon v-if="prompt.icon" :name="prompt.icon" />
                        <h1>{{ prompt.prompt }}</h1>
                    </div>
                </div>
                <div class="cargando-sugerencias" v-if="promptSuggestions.length === 0">
                    <h1>Cargando sugerencias...</h1>
                </div>
            </div>
            <div v-if="!isModal" class="login-footer-2">
                <nav>
                    <RouterLink :to="{ name: 'terms-of-service' }">Términos del Servicio</RouterLink>
                    <RouterLink :to="{ name: 'privacy-policy' }">Política de Privacidad</RouterLink>
                    <a target='_blank'
                        href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">Contactanos</a>
                </nav>
            </div>
        </div>
        <div class="login-der">
            <div v-if="!isModal || (isModal && showModal)" class="login-content">
                <div class="logo-outter">
                    <img class="logo" src="@/assets/isologotipo_chatpts_transparente.svg" alt="Logo de ChatPTS">
                    <h2 class="sublogo">Un chat que toma Partido 😉</h2>
                </div>
                <div class="login-der-der">
                    <h2 v-if="!isModal">✨ Chateá con La Izquierda Diario, el semanario Ideas de Izquierda, la revista
                        Armas
                        de
                        la Crítica y las
                        publicaciones y libros del IPS-CEIP, con grandes clásicos del marxismo y publicaciones de
                        autores
                        contemporáneos.</h2>
                    <h2 v-if="isModal">✨ Iniciá sesión para ver este contenido.</h2>
                    <div class="login-controls">
                        <div v-if="show_email_login" class="login-controls-top">
                            <div class="custom-input">
                                <input autofocus type="email" required @focusin="showemails" class="avoidblur"
                                    v-model="email" v-on:focusout="hideemails"
                                    placeholder="Email o identificador de usuario" @keyup.enter="accept" />
                                <div v-if="show_email_list" class="emails-list">
                                    <div class="email-item" v-for="email in saved_emails" :key="email"
                                        v-on:mouseenter="preselectemail(email)" @click="selectemail(email)">
                                        {{ email }}
                                    </div>
                                </div>
                            </div>
                            <button @click="accept">Vamos</button>
                        </div>
                        <div v-if="show_email_login && show_google_login" class="login-controls-bottom">
                            - ó -
                        </div>
                        <div v-if="show_google_login" class="login-controls-bottom">
                            <div v-if="this.mode != 'development'" id="buttonDiv">Continuar con Google</div>
                            <div v-else @click="fakeLocalLogin">Fake Local Login</div>
                            <div v-if="this.mode === 'development'" @click="fakeLocalLoginNoSubscription"
                                class="fake-login-button">Fake Local Login (No
                                Subscription)</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <img id="portal" src="@/assets/portal.webp" :alt="botname" @click="hideemails" /> -->

    </div>
</template>

<script>
import axios from 'axios';
import { useAuth } from '@/composables/useAuth';
axios.defaults.withCredentials = true;

export default {
    data() {
        return {
            email: '',
            name: '',
            permissions: [],
            saved_emails: [],
            show_email_list: false,
            botname: process.env.VUE_APP_BOT_PUBLIC_NAME,
            promptSuggestions: [],
            show_email_login: false,
            show_google_login: true,
            mode: process.env.VUE_APP_ENV,
            profilePicture: '',
            subscription: {}
        };
    },
    props: {
        isModal: {
            type: Boolean,
            default: false,
        },
        showModal: {
            type: Boolean,
            default: false,
        },
        getMeCallback: {
            type: Function,
            default: () => { },
        },
    },
    methods: {
        accept() {
            // Handle the accept button click event here
            // You can access the entered email using this.email
            this.$emit('user-set', this.email, this.name, this.permissions, this.profilePicture, this.subscription);

            // Save to local storage
            const saved_emails = localStorage.getItem('emails');
            const emails = saved_emails ? saved_emails.split(',') : [];
            const new_emails = [...new Set([this.email, ...emails])];
            localStorage.setItem('emails', new_emails.join(','));
        },
        showemails() {
            const saved_emails = localStorage.getItem('emails');
            const raw_email_list = saved_emails ? saved_emails.split(',') : [];
            // remove whitespace and split by comma
            const sanitized_email_list = raw_email_list.map(email => email.trim());
            // remove empty strings
            this.saved_emails = sanitized_email_list.filter(email => email);
            if (this.saved_emails.length > 0) {
                this.show_email_list = true;
            }
        },
        hideemails(e) {
            // Stop propagation to avoid hiding the email list when clicking on it
            e.stopPropagation();
            this.show_email_list = false;
        },
        selectemail(email) {
            this.email = email;
            this.show_email_list = false;
        },
        preselectemail(email) {
            this.email = email;
        },
        getPromptSuggestions() {
            axios.get(process.env.VUE_APP_BASE_URL + '/api/v2/public-prompt-suggestions/')
                .then(response => {
                    this.promptSuggestions = response.data;
                })
                .catch(error => {
                    console.error('Error fetching prompt suggestions:', error);
                    this.showToast("¡Estamos con mucha demanda! al intentar obtener sugerencias de prompts.", "warning");
                });
        },
        handleCredentialResponse(response) {
            // Send the ID token (credential) to your backend for verification
            axios
                .post(
                    process.env.VUE_APP_BASE_URL + '/api/auth/google/callback/',
                    { credential: response.credential, country: process.env.VUE_APP_COUNTRY },
                    { withCredentials: true } // Include if you need to send cookies
                )
                .then((res) => {
                    // The response data is already parsed as JSON
                    const { message } = res.data;
                    if (res.status === 200 && "Login successful" === message) {
                        this.getUserData();
                    } else {
                        console.error('Authentication failed:', message);
                        this.showToast('Error al iniciar sesión. Por favor, intentá de nuevo. Código de error: "' + message + '"', 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        // The request was made, and the server responded with a status code outside 2xx
                        console.error('Authentication failed:', err.response.data.detail);
                        this.showToast('Error al iniciar sesión. Por favor, intentá de nuevo. Código de error: "' + err.response.data.detail + '"', 'error');
                    } else if (err.request) {
                        // The request was made, but no response was received
                        console.error('No response received:', err.request);
                        this.showToast('Error al iniciar sesión. Por favor, intentá de nuevo. Código de error: "' + err.request + '"', 'error');
                    } else {
                        // Something happened in setting up the request
                        console.error('Error during authentication:', err.message);
                        this.showToast('Error al iniciar sesión. Por favor, intentá de nuevo. Código de error: "' + err.message + '"', 'error');
                    }
                });
        },
        fakeLocalLogin() {
            // make a POST request to /auth/google/callback with body {  "credential": "credenZial"}
            axios
                .post(
                    process.env.VUE_APP_BASE_URL + '/api/auth/google/callback/',
                    { credential: 'credenZial' },
                    { withCredentials: true } // Include if you need to send cookies
                )
                .then((res) => {
                    // The response data is already parsed as JSON
                    const { message } = res.data;
                    if (res.status == 200 && "Login successful" === message) {
                        this.getUserData();
                    } else {
                        console.error('Authentication failed:', message);
                        this.showToast('Error al iniciar sesión. Por favor, intentá de nuevo. Código de error: "' + message + '"', 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        // The request was made, and the server responded with a status code outside 2xx
                        console.error('Authentication failed:', err.response.data.detail);
                    } else if (err.request) {
                        // The request was made, but no response was received
                        console.error('No response received:', err.request);
                    } else {
                        // Something happened in setting up the request
                        console.error('Error during authentication:', err.message);
                    }
                });
        },
        fakeLocalLoginNoSubscription() {
            // make a POST request to /auth/google/callback with body {  "credential": "credenZial2"}
            axios
                .post(
                    process.env.VUE_APP_BASE_URL + '/api/auth/google/callback/',
                    { credential: 'credenZial2' },
                    { withCredentials: true } // Include if you need to send cookies
                )
                .then((res) => {
                    // The response data is already parsed as JSON
                    const { message } = res.data;
                    if (res.status == 200 && "Login successful" === message) {
                        this.getUserData();
                    } else {
                        console.error('Authentication failed:', message);
                        this.showToast('Erro ao fazer login. Por favor, tente novamente. Código de erro: "' + message + '"', 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        // The request was made, and the server responded with a status code outside 2xx
                        console.error('Authentication failed:', err.response.data.detail);
                    } else if (err.request) {
                        // The request was made, but no response was received
                        console.error('No response received:', err.request);
                    } else {
                        // Something happened in setting up the request
                        console.error('Error during authentication:', err.message);
                    }
                });
        },
        async getUserData(withToast = true) {
            if (this.getMeCallback && this.isModal) {
                this.getMeCallback();
                return;
            }

            const { user, checkAuth } = useAuth();
            const isValid = await checkAuth(withToast);

            if (isValid) {
                // Actualizar los datos locales del componente con los del composable
                this.email = user.email;
                this.name = user.name;
                this.permissions = user.permissions;
                this.profilePicture = user.profilePicture;
                this.subscription = user.subscription;

                this.accept();
            }
        },
        showToast(message, type) {
            this.$emit('show-toast', message, type);
        },
        loadGoogleScript() {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;

            script.onload = () => {
                this.initializeGoogleSignIn();
            };

            document.head.appendChild(script);
        },

        initializeGoogleSignIn() {
            window.google.accounts.id.initialize({
                client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                callback: this.handleCredentialResponse,
            });
            window.google.accounts.id.renderButton(
                document.getElementById('buttonDiv'),
                { theme: 'filled_blue', size: 'large' }
            );
        },

    },
    mounted() {
        this.getPromptSuggestions();
        if (this.mode != 'development') {
            this.loadGoogleScript();
        }
        this.getUserData(false);
    },
};
</script>

<style scoped>
.login-component.login-modal-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    padding: 0;
    margin: 0;
}

.login-component.login-modal-container .login-content {
    margin-top: 0;
}


.logo {
    max-width: 300px;
    margin-bottom: 12px;
}

.sublogo {
    color: #a1344e !important;
    font-weight: 600 !important;
}

.login-component {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
}

.login-izq,
.login-der {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(250, 250, 250, 0.85);
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.6);
    color: #333333;
    border-radius: 8px;
    min-height: 80vh;
    flex-grow: 0;
    width: 50%;
    margin: 24px;
}

.login-der {
    padding: 24px 48px;
    margin-bottom: 24px;
}

.login-content {
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14pt;

}

.login-footer {
    max-width: 1200px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
    margin-bottom: 48px;
    width: 100%;
}

.login-controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.login-controls-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.login-controls-bottom {
    margin-top: 24px;
    color: #333;
}


.login-component input {
    margin-right: 24px;
    font-size: 14pt;
    padding: 12px;
    flex-grow: 2;
    height: 100%;
    margin-bottom: 0;
}

.login-component button {
    font-size: 14pt;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: #a1344e;
    color: #333;
    cursor: pointer;
    align-self: stretch;
    flex-grow: 1;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: bold;
}

.login-component h1 {
    font-size: 48pt;
    margin-bottom: 24px;
    color: #a1344e;
    letter-spacing: 20px;
}

.login-component h2 {
    color: #333;
    font-weight: 400;
    font-size: 16pt;
    margin-bottom: 64px;
}

.login-footer a {
    max-width: 325px;
    margin: 12px;
}

.login-footer img {
    width: 100%;
}

#portal {
    width: 100%;
    opacity: 0.1;
}



.custom-input {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-grow: 2;
}

.emails-list {
    position: absolute;
    background-color: #333;
    border-radius: 4px;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.4);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    top: 100%;
    padding: 12px;
    z-index: 2;
}

.email-item {
    padding: 8px;
    cursor: pointer;
}

.email-item:hover {
    background-color: #333;
}



.prompt-suggestions-carrousel {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 500px;
    height: 100%;
    margin-bottom: 120px;
    overflow-x: hidden;
    z-index: 1;
}

.prompt-suggestions-slides-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.prompt-suggestions-slides-container>div {
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 12px;
    border: 2px solid #333;
    border-radius: 8px;
    padding: 12px;
    width: 33%;
    flex-shrink: 0;
    transition: all 0.3s ease-in;
}

.prompt-suggestions-slides-container>div:hover {
    background-color: #a1344e;
    color: #f0f0f0;
    /* cursor: pointer; */
}

.prompt-suggestions-slides-container>div:hover ion-icon {
    color: #f0f0f0;
}

.prompt-suggestions-slides-container>div:hover h1 {
    color: #f0f0f0;
}




.prompt-suggestions-carrousel h1 {
    font-size: 14pt;
    color: #333;
    margin: 12px;
    letter-spacing: normal;
}

.prompt-suggestions-carrousel ion-icon {
    font-size: 20pt;
    margin-right: 10px;
    color: #a1344e;
    flex-shrink: 0;
}

/* Animation to move the prompt suggestions */
.prompt-suggestions-slides-container {
    animation: move 20s linear infinite;
}

.cargando-sugerencias {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 124px;
    padding: 12px;
}

.login-footer-2 {
    padding-bottom: 24px;
    color: #333 !important;
}

.login-footer-2 a {
    color: #333 !important;

}

.login-footer-2 a:visited {
    color: #333 !important;
}



.login-footer-2 nav>* {
    margin: 12px;
}

@keyframes move {
    0% {
        transform: translateX(5%);
    }

    99% {
        transform: translateX(-95%);
    }

    100% {
        transform: translateX(5%);
    }
}

@media (max-width: 1100px) {
    .login-component {
        justify-content: flex-start;
        height: 100%;
        flex-direction: column;
        padding: 12px;
    }

    .login-izq,
    .login-der {
        width: 100%;
        max-width: 900px;
        height: auto;
        margin: 0;
        padding: 24px;
    }

    .login-izq {
        order: 2;
        padding: 24px;
        min-height: auto;
        align-items: center;
    }

    .login-der {
        order: 1;
        margin-bottom: 12px;
    }

    .login-content {
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
    }

    .logo-outter {
        padding-bottom: 24px;
        margin-right: 48px;
        margin-left: 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .login-der h2 {
        margin-right: 24px;
        margin-bottom: 0;
        text-align: justify;
    }

    .login-footer {
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .prompt-suggestions-carrousel {
        width: 90%;
    }

    .login-der-der {
        max-width: 50%;
    }
}

/* mobile */
@media (max-width: 768px) {
    .logo {
        width: 60%;
        max-width: 300px;
    }



    .login-content {
        padding: 24px;
        padding-top: 36px;
        margin-bottom: 24px;
    }


    .login-component {
        justify-content: flex-start;
        height: 100%;
        flex-direction: column;
        padding: 12px;
    }

    .login-izq,
    .login-der {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 12px;
    }

    .login-izq {
        order: 2;
        padding: 24px;
        min-height: auto;
    }

    .login-der {
        order: 1;
        margin-bottom: 12px;
        flex-direction: column;
    }

    .login-content {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .logo-outter {
        margin: 0;
        margin-bottom: 48px;
        padding: 0;
    }

    .login-der-der {
        max-width: 90%;
    }

    .login-component h1 {
        margin-bottom: 48px;
        letter-spacing: normal;
    }

    .login-component h2 {
        font-size: 14pt;
        margin-bottom: 24px;
        margin-right: 0;
    }

    .login-footer {
        padding: 12px;
        background-color: rgba(175, 175, 175, 0.8);
        flex-direction: column;
    }


    .login-controls {
        flex-direction: column;
    }

    .custom-input {
        width: 100%;
        margin-bottom: 12px;
    }

    .custom-input input {
        margin-right: 0;
        width: 100%;
    }

    .prompt-suggestions-carrousel {
        width: 100%;
        margin-bottom: 24px;
    }

    .prompt-suggestions-slides-container>div {
        width: 70vw;
        overflow: hidden;
    }

    .login-footer a {
        width: 80%;
        max-height: 60px;
        margin: 6px;
    }

    .login-footer a:first-child {
        margin-bottom: 12px;
    }


    .login-footer a img {
        height: 100%;
    }


    .prompt-suggestions-carrousel h1 {
        font-size: 12pt;
        margin-bottom: 0;
        margin-top: 0;
    }

    .login-footer-2 nav {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
}
</style>
